import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import UserLayout from "../../components/user/UserLayout";
import { Card, Row, Col, Form, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const DiseasesPage = () => {
  const [diseases, setDiseases] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const loadDiseases = async () => {
    try {
      const res = await api.get("/diseases");
      setDiseases(res.data);
    } catch (err) {
      console.error("Hastalıklar alınamadı:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDiseases();
  }, []);

  const filtered = diseases.filter(
    (d) =>
      d.name.toLowerCase().includes(search.toLowerCase()) ||
      d.description.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <UserLayout>
      {/* Sayfa Başlığı */}
      <div className="mb-4">
        <h2 className="fw-bold" style={{ color: "#2D8A7A" }}>
          Hastalıklar
        </h2>
        <div
          style={{
            height: "3px",
            width: "70px",
            backgroundColor: "#2D8A7A",
            borderRadius: "5px",
          }}
        ></div>
      </div>

      {/* Arama Kutusu */}
      <Form.Control
        type="text"
        placeholder="Hastalık ara..."
        className="mb-4 shadow-sm"
        style={{
          borderRadius: "12px",
          padding: "14px",
          borderColor: "#cde6df",
        }}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" />
        </div>
      ) : filtered.length === 0 ? (
        <div className="text-center py-5 text-muted">
          Arama kriterlerine uygun hastalık bulunamadı.
        </div>
      ) : (
        <Row className="g-4">
          {filtered.map((d, index) => (
            <Col md={4} key={d._id}>
              <motion.div
                initial={{ opacity: 0, y: 25 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05, duration: 0.4 }}
              >
                <Card
                  className="shadow-sm rounded-4 overflow-hidden"
                  style={{
                    border: "none",
                    background: "rgba(255,255,255,0.85)",
                    backdropFilter: "blur(8px)",
                    transition: "0.25s",
                  }}
                >
                  {/* Görsel */}
                  <div style={{ height: "220px", overflow: "hidden" }}>
                    <img
                      src={d.imageUrls?.[0] || "/placeholder.jpg"}
                      alt={d.name}
                      className="img-fluid w-100"
                      style={{
                        objectFit: "cover",
                        height: "100%",
                        transition: "0.3s",
                      }}
                    />
                  </div>

                  {/* Kart İçeriği */}
                  <Card.Body>
                    <h5
                      className="fw-bold mb-2"
                      style={{ color: "#2D8A7A" }}
                    >
                      {d.name}
                    </h5>

                    <p
                      className="text-muted"
                      style={{
                        minHeight: "50px",
                        fontSize: "0.95rem",
                        lineHeight: "1.4",
                      }}
                    >
                      {d.description.substring(0, 90)}...
                    </p>

                    <Link
                      to={`/panel/diseases/${d._id}`}
                      className="btn btn-primary w-100 rounded-pill shadow-sm"
                      style={{ fontWeight: 500 }}
                    >
                      İncele
                    </Link>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      )}
    </UserLayout>
  );
};

export default DiseasesPage;
